module.exports = __webpack_public_path__ + "img/love.b89cbb24.png";